import { useState, useEffect } from "react";
import styled from 'styled-components';
import { Modal, Button, LoadingIcon } from '@prosolve/common-components-ui'
import useForm from '../../hooks/useForm';
import useFetch from '../../hooks/useFetch';
import { FormField } from '@prosolve/common-components-ui'

const Header = styled.div`
  display: flex;
  align-items: center;
  color: #565656;
  font-weight: bold;
`

const Title = styled.div`
  font-size: 22px;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  column-gap: 10px;
  padding: 10px;
`

export default ({
  currentFolderName = '',
  assessments = [],
  reloadData,
  onClose,
  onConfirmation
}) => {
  const fetch = useFetch();

  const formSchema = {
    requiredFields: ['folder'],
    initData: { folder: currentFolderName }
  }

  const formData = useForm(formSchema)

  const [isValid, setIsValid] = useState(false)

  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    const { folder } = formData.values
    if (folder && (currentFolderName !== folder ) && assessments.length > 0) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.values])

  const onSubmit = async () => {
    if (isValid) {
      try {
        setIsBusy(true)
        const { folder } = formData.values

        const bodyObj = {
          assessmentIds: assessments.map(({ _id }) => _id),
          folder
        }

        const response = await fetch(`assessment/builder/setFolder`, 
        { 
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(bodyObj)
        })

        const jsonData = await response.json();

        if (jsonData.success) {
          reloadData()
          onClose()
        }

        setIsBusy(false)
      } catch (e) {
        console.log(e)
        setIsBusy(false)
      }
    }
  }

  const TitleComponent = (
    <Header>
      <Title>
        {'Rename Folder'}
      </Title>
    </Header>
  )

  const baseButtonStyle = {
    padding: '10px',
    fontSize: '18px',
    borderRadius: '10px',
    width: '100px'
  }

  const FooterComponent = (
    <ButtonsContainer>
      <Button style={baseButtonStyle} onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button style={{ ...baseButtonStyle, fontWeight: 'bold', position: 'relative' }} onClick={onSubmit} $colored={true} $disabled={!isValid || isBusy}>
        {
          isBusy ?
          <>
            &nbsp;
            <div style={{ position: 'absolute', top: '3px' }}>
              <LoadingIcon />
            </div>
          </>
          :
          'Submit'
        }
      </Button>
    </ButtonsContainer>
  )

  return (
    <Modal 
      title={TitleComponent}
      // isAutoHeight={true} 
      closeOnOffClick={false}
      footer={FooterComponent} 
      onClose={onClose}
    >
      <Content>
        <FormField
          fieldId='folder'
          type='text'
          label='Rename Folder'
          formData={formData}
        />
      </Content>
    </Modal>
  )
}